import React from 'react';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffPeiksNew(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formTitle, setFormTitle] = useState(null);
    const [formVehicle, setFormVehicle] = useState(null);
    const [formPhoneOne, setFormPhoneOne] = useState(null);
    const [formPhoneTwo, setFormPhoneTwo] = useState(null);
    const [formOptimeId, setFormOptimeId] = useState(null);
    const [formOptimeUsername, setFormOptimeUsername] = useState(null);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-peiks-new/save-data', {
            title: formTitle,
            vehicle: formVehicle,
            phone_one: formPhoneOne,
            phone_two: formPhoneTwo,
            optime_id: formOptimeId,
            optime_username: formOptimeUsername,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    return (
        <PanelBox>
            <DataForm>
                <Title>ایجاد پیک</Title>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'عنوان'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'نوع وسیله'}
                            value={formVehicle}
                            onChange={setFormVehicle}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'شماره همراه یک'}
                            value={formPhoneOne}
                            onChange={setFormPhoneOne}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'شماره همراه دو'}
                            value={formPhoneTwo}
                            onChange={setFormPhoneTwo}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'شناسه آپتایم'}
                            value={formOptimeId}
                            onChange={setFormOptimeId}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'نام کاربری آپتایم'}
                            value={formOptimeUsername}
                            onChange={setFormOptimeUsername}
                        />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
